import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { CommonService } from './common.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptorService implements HttpInterceptor {

  token: any;
  constructor(private inject: Injector, private commonService: CommonService) { }


  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.token = this.commonService.getCookie('sfxTrackToken');
    if (!this.token) {
      this.token = environment.sfxTrackStaticToken
    }
    if (req.url.indexOf('veve.com') !== -1) {
      return next.handle(req);
    }
    const tokenizedReq = req.clone({ headers: req.headers.set('Authorization', 'Token ' + this.token) });
    return next.handle(tokenizedReq);

  }
}
